import React from "react";

import NewEmployeeForm from "./NewEmployeeForm";
import NewEmployeeShow from "./NewEmployeeShow";

import { connect } from "react-redux";
const NewEmployee = ({ newEmployeeInfo }) => {
  return (
    <>{newEmployeeInfo === null ? <NewEmployeeForm /> : <NewEmployeeShow />}</>
  );
};

export const mapStateToProps = (props) => {
  const { managementReducer } = props;
  const { newEmployeeInfo } = managementReducer;

  return { newEmployeeInfo };
};

export default connect(mapStateToProps)(NewEmployee);
